// extracted by css-extract-rspack-plugin
export default {"sectionsList":"sectionsList-2ZiJy","videoIntroduction":"videoIntroduction-1nikH","imageWrapper":"imageWrapper-1q7ER","textWrapper":"textWrapper-EYjhx"};